module.exports = __webpack_public_path__ + "img/logo_payme.515ee029.png";